/**
 * Web Style Import
 *
 */

import './style/dnb-button.scss'
